import YoutubePage from "../../components/youtube-page/youtube-page.component";
const Youtube = () => {
    return (
        <div>
            <YoutubePage />
        </div>
    );
}

export default Youtube;